import * as Yup from "yup";
export var validationSchema = Yup.object({
    name: Yup.string().required(),
});
